import { BookmarkSimpleIcon } from "@phosphor-icons/react/dist/ssr/BookmarkSimple";
import { HeartIcon } from "@phosphor-icons/react/dist/ssr/Heart";
import { StarIcon } from "@phosphor-icons/react/dist/ssr/Star";
import { createAppIcon } from "./base";

// Explicit selected states must remain visually different from empty controls.
export const BookmarkSelected = /* @__PURE__ */ createAppIcon(
  BookmarkSimpleIcon,
  "BookmarkSimple",
  "fill",
);
export const HeartSelected = /* @__PURE__ */ createAppIcon(
  HeartIcon,
  "Heart",
  "fill",
);
export const StarSelected = /* @__PURE__ */ createAppIcon(
  StarIcon,
  "Star",
  "fill",
);
